<script setup lang="ts">
import { useRoute } from 'vue-router'
import { AUTHMODELHS } from '@/utils/models'
import { useAuthStore } from '@/stores/auth.store'
import authService from '@/services/auth.service'
import utilModelsService from '@/services/util.models.service'
import closeIcon from '@/assets/images/svg/AuthOnboarding/CloseButton.svg'
import LoginRegisterBanner from '@/components/header/auth/AuthOnboardingAdvBanner/LoginRegisterBanner.vue'
import AuthOnboardingLabel from '@/components/header/auth/AuthOnboardingLabel.vue'
import Button from '@/components/atoms/button/index.vue'
import ModelLayoutAuth from '@/layouts/ModelLayoutAuth.vue'
import { useOrganisationStore } from '@/stores/organisation.store'
import { computed } from 'vue'

const route = useRoute()
const authStore = useAuthStore()

const organisationStore = useOrganisationStore()

const invitations = computed(() => {
  return organisationStore.userInvitations
})

/**
 * If prop is true, page retrieves data again from API after changes from modal
 */
const handleLoadDataWhenClose = async () => {
  authStore.setRedirectTo(null)
  await authService.initAuth(true)
}
/**
 * Redirect to home page after OTP verification
 */
const continueRedirectToHome = async () => {
  if (invitations.value && invitations.value?.length > 0) {
    await authService.initAuth(true, false)
    utilModelsService.closeModal(AUTHMODELHS.OTPVERIFIEDSUCCESS)
    utilModelsService.openModal(AUTHMODELHS.INVITEACCEPT)
  } else {
    await authService.initAuth(true)
    utilModelsService.closeModal(AUTHMODELHS.OTPVERIFIEDSUCCESS)
  }
}
</script>

<template>
  <ModelLayoutAuth :hs="AUTHMODELHS.OTPVERIFIEDSUCCESS">
    <div class="flex h-screen w-full flex-col">
      <div class="absolute right-0 flex justify-end">
        <img
          :src="closeIcon"
          alt="Close"
          class="link-primary hs-collapse-toggle mr-5 mt-2 h-[20px] w-[20px] cursor-pointer transition-all"
          :data-hs-overlay="`#${AUTHMODELHS.LOGIN}`"
          @click="handleLoadDataWhenClose"
          v-show="!(route.name === 'extensionLogin' && !route.query.register)"
        />
      </div>
      <div class="flex w-full flex-1 p-1 sm:p-5">
        <div class="hidden w-full rounded-3xl bg-[#EBEFF6] md:hidden lg:block lg:min-w-[45%]">
          <LoginRegisterBanner
            text="A feature-rich coding suite powered by AI"
            highlighertext="powered by AI"
          />
        </div>

        <div class="mt-10 h-full w-full rounded-md sm:mt-8 lg:min-w-[50%]">
          <div class="flex flex-col items-center justify-center">
            <div>
              <AuthOnboardingLabel
                title="OTP successfully verified"
                customstyle="mt-5 text-sky-950 text-xl font-medium leading-7 text-center sm:text-start xl:text-start 2xl:text-start"
                customstyleTitle="text-center text-3xl font-medium leading-10"
              />
            </div>
            <div class="mt-10 flex w-full items-start justify-center">
              <div
                class="flex flex-col items-center sm:items-center lg:w-[90%] xl:ml-1 xl:items-center"
              >
                <div
                  class="flex flex-col flex-wrap items-center gap-2 sm:items-center lg:flex-col xl:flex-row xl:items-center 2xl:flex-row"
                >
                  <span class="text-lg font-normal leading-7">
                    Now you can save projects in JDoodle IDE, get more JDroid credits, and access
                    advanced features like Compiler APIs and Embeds.
                  </span>
                  <span class="mt-2 w-full text-lg font-normal leading-7"> Happy Coding! </span>
                </div>
              </div>
            </div>
            <div class="mt-28 flex w-full items-center justify-center p-5 sm:w-44 sm:p-0">
              <Button
                type="submit"
                @click="continueRedirectToHome"
                color="secondary"
                variant="filled"
                size="medium"
                class="sm:w-44"
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- form -->
  </ModelLayoutAuth>
</template>
